import { render, staticRenderFns } from "./weishen.vue?vue&type=template&id=85a27d4a"
import script from "./weishen.vue?vue&type=script&lang=js"
export * from "./weishen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports